import {
  ApplicationConfig,
  importProvidersFrom,
  isDevMode,
  LOCALE_ID,
  PLATFORM_ID,
} from '@angular/core';
import {
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
  withXhr,
} from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideServiceWorker } from '@angular/service-worker';
import { isPlatformBrowser, registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeDe from '@angular/common/locales/de';
import localeLb from '@angular/common/locales/lb';
import localeNl from '@angular/common/locales/nl';
import localePt from '@angular/common/locales/pt';
import {
  commonsProviders,
  commonsProvidersFrom,
} from './config/commons.config';
import { initProvider } from './config/init.config';
import { employeeInterceptor } from './interceptor/employee.interceptor';

registerLocaleData(localeFr, 'fr');
registerLocaleData(localePt, 'pt');
registerLocaleData(localeDe, 'de');
registerLocaleData(localeNl, 'nl');
registerLocaleData(localeLb, 'lu');

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(
      withXhr(),
      withInterceptorsFromDi(),
      withInterceptors([employeeInterceptor]),
    ),
    provideRouter(appRoutes),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode() && isPlatformBrowser(PLATFORM_ID),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    initProvider,
    importProvidersFrom(...commonsProvidersFrom),
    commonsProviders,
    { provide: LOCALE_ID, useValue: 'fr' },
  ],
};
